<template>
	<AppDialog dialogName="NewSubflowBlockDialog">
		<div class="new-subflow-block-dialog">
			<div class="dialog-title">Create subflow</div>
			<div class="dialog-description">
				Subflows allow you to reuse a collection of steps in multiple features. <span class="link-text">Learn more</span>
			</div>
			<SubflowUpgradeRequiredBadge />
			<div class="dialog-body mt-3">
				<InfoSection>
					<div class="info-box flex-start--center mt-2 mb-2">
						<SIcon class="mr-5 ml-3" name="lightbulb" />
						<div>
							The easy way to create a subflow is to build functionality in an existing feature and then convert it into a subflow by
							clicking the step options menu.
						</div>
					</div>
				</InfoSection>
				<div class="paragraph-title mt-5 font-weight-600">How it works?</div>
				<div class="paragraph-description mt-2">
					<div class="mb-1">1. Create a subflow</div>
					<div class="mb-1">2. Define input and output data</div>
					<div class="mb-1">3. Add the subflow to a feature</div>
				</div>
				<div class="paragraph-title mt-5">Subflow name</div>
				<AppTextField v-model="subflowName" ref="subflow_name" class="mt-2" outlined />
			</div>
			<div class="dialog-bottom flex-centerize flex-column">
				<div class="subtle-message font-size-xs mb-1">Opens in a new tab</div>
				<SecondaryButton large @click="createAndOpenSubflow" :disabled="subflowName.length < 2 || loading" :loading="loading">
					Create and open <SIcon name="external-link" />
				</SecondaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import SubflowUpgradeRequiredBadge from '@/components/dialogs/Subflows/SubflowUpgradeRequiredBadge.vue';
import { createSubflow } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'NewSubflowBlockDialog',
	components: {
		AppDialog,
		SubflowUpgradeRequiredBadge,
	},
	props: {
		dialogPromiseHandlers: { type: Object },
		projectId: { type: Number },
	},
	data() {
		return { subflowName: '', loading: false };
	},
	methods: {
		...mapActionsShorthand({ createSubflow }),
		close(params) {
			this.dialogPromiseHandlers.resolve(params);
			AppDialogManagerService.closeCurrentDialog();
		},
		cancel() {
			this.close();
		},
		async createAndOpenSubflow() {
			const { subflowName, projectId } = this;
			this.loading = true;
			try {
				const subflow = await this.createSubflow({ projectId, subflowName });
				if (subflow?.error) {
					this.$toast.error(`Failed to create subflow, please try again`);
				} else {
					const routeData = this.$router.resolve({ name: 'Feature', params: { wfID: subflow.id, pID: subflow.project } });
					window.open(routeData.href, '_blank');
					this.close({ subflowId: subflow.id });
				}
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.subflow_name.focus();
		});
	},
};
</script>

<style scoped lang="scss">
.new-subflow-block-dialog {
	border-radius: 15px !important;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}

	.dialog-body {
		max-height: 400px;
		overflow: auto;

		.info-box {
			color: #596ee1;
		}
	}

	.dialog-bottom {
		::v-deep(.v-btn) {
			min-height: 45px !important;
			border-radius: 12px !important;

			svg {
				margin: 4px 0 0 8px !important;

				path {
					stroke: white !important;
				}
			}

			&.v-btn--disabled svg path {
				stroke: #ababab !important;
			}
		}
	}
}
</style>
